import React, { useState, useEffect } from "react";
import "./App.css";
import "./styles-mobile.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AboutMe from "./components/AboutMe";
import ChatCJR from "./components/ChatCJR"; // NEW
import { NavBar } from "./components/NavBar";
import { Skills } from "./components/Skills";
import { Footer } from "./components/Footer";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import ProjectDetail from "./components/ProjectDetail";
import TimelineApp from "./components/timelineApp";
import SplineScene from "./components/SplineScene";

function AppContent() {
    const navigate = useNavigate();
    const location = useLocation();
    
    const [language, setTragetLanguage] = useState('en');

    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [isSkillsOpen, setIsSkillsOpen] = useState(false);

    // Scroll to top on route change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        console.log("isSkillsOpen changed:", isSkillsOpen);
    }, [isSkillsOpen]);

    const handleLanguageChange = (lang) => {
        setTragetLanguage(lang);
        localStorage.setItem('language', lang);
    };

    const handleNavbarToggle = () => {
        setIsNavbarOpen((prev) => !prev);
    };

    return (
        <div className="App">
            <div className={`app ${isNavbarOpen ? "nav-open" : ""}`}>
                <NavBar
                    isOpen={isNavbarOpen}
                    onToggle={handleNavbarToggle}
                    language={language}
                    onLanguageChange={handleLanguageChange}
                    setIsSkillsOpen={setIsSkillsOpen}
                />

                <main className="main-content" role="main">
                    {location.pathname === "/" && (
                        <SplineScene setIsSkillsOpen={setIsSkillsOpen} language={language} languageSelected={true} />
                    )}

                    <Routes>
                        <Route path="/projects/:id" element={<ProjectDetail />} />
                        <Route path="/timeline" element={<TimelineApp language={language} />} />
                        <Route path="/skills" element={<Skills language={language} />} />
                        <Route path="/about" element={<AboutMe />} /> {/* About page */}
                        <Route
                            path="/chat"
                            element={
                                <ChatCJR
                                    language={language}
                                    onLanguageChange={handleLanguageChange}
                                />
                            }
                        /> {/* Chat page */}
                        <Route path="/" element={null} />
                    </Routes>
                </main>

                {isSkillsOpen && (
                    <div className="skills-modal">
                        <Skills language={language} />
                        <button
                            className="close-skills-btn"
                            onClick={() => setIsSkillsOpen(false)}
                        >
                            ×
                        </button>
                        <div className="modal-navigation" style={{
                            position: "fixed",
                            bottom: "20px",
                            left: "0",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            gap: "20px",
                            zIndex: 9999
                        }}>
                            <button className="nav-btn" onClick={() => {
                                setIsSkillsOpen(false);
                                navigate("/");
                            }}>Home</button>
                            <button className="nav-btn" onClick={() => {
                                setIsSkillsOpen(false);
                                navigate("/timeline");
                            }}>Projects</button>
                        </div>
                    </div>
                )}

                <Footer />
            </div>
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;